import { useQuery } from "@apollo/client";
import { GET_INFO } from "../graphql";
import { EditInfoForm } from "./edit";
import { useParams } from "react-router-dom";
import { LoadingOverlay } from "../../../components/Loading";
import { SecondForm } from "./secondForm";
import { Stack } from "@mui/material";

export const EditInfo = () => {
  const { id } = useParams();
  const { data, refetch } = useQuery(GET_INFO, {
    variables: {
      id: id!,
    },
  });

  if (!data?.info) return <LoadingOverlay loading={true} />;

  const sorted = [...(data?.info?.value?.items ?? [])].sort(
    (a, b) => (a?.order ?? 0) - (b?.order ?? 0)
  );

  return (
    <Stack spacing={2}>
      <EditInfoForm info={data.info} refetch={refetch} />
      <SecondForm info={data.info} items={sorted} refetch={refetch} />
    </Stack>
  );
};
